import type { Tone } from "./types";

/**
 * Define as variáveis `--tone*` no elemento para que um mesmo conjunto de
 * classes (`text-(--tone)`, `bg-(--tone-soft)`) sirva a
 * todos os tons semânticos sem uma combinação variante × tom por classe.
 */
export const toneVars: Record<Tone, string> = {
  ink: "[--tone:var(--primary)] [--tone-soft:var(--ov-3)]",
  accent: "[--tone:var(--accent)] [--tone-soft:var(--accent-soft)]",
  success: "[--tone:var(--success)] [--tone-soft:var(--success-soft)]",
  error: "[--tone:var(--error)] [--tone-soft:var(--error-soft)]",
  warning: "[--tone:var(--warning)] [--tone-soft:var(--warning-soft)]",
  info: "[--tone:var(--info)] [--tone-soft:var(--info-soft)]",
};
